import type { Chord } from 'svguitar';

export const CChords: Record<string, Chord> = {
  C: {
    fingers: [
      [1, 0],
      [2, 1, '1'],
      [3, 0],
      [4, 2, '2'],
      [5, 3, { text: '3', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'C',
    position: 0,
  },
  C7: {
    fingers: [
      [1, 0],
      [2, 1, '1'],
      [3, 3, '4'],
      [4, 2, '2'],
      [5, 3, { text: '3', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'C7',
    position: 0,
  },
  C9: {
    fingers: [
      [1, 3, '4'],
      [2, 3, '3'],
      [3, 0],
      [4, 2, '2'],
      [5, 3, { text: '3', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'C9',
    position: 0,
  },
  Cm: {
    fingers: [
      [2, 4, '2'],
      [3, 5, '4'],
      [4, 5, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 3,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Cm',
    position: 0,
  },
};
